import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    doListSlackChannels,
    doCreateSlackChannel,
    selectSlackChannels,
    selectIsLoading,
    selectError
} from 'app/store/integrations/slack';
import { SlackChannelSelect } from './SlackChannelSelect.jsx';

const mapStateToProps = createStructuredSelector({
    channels: selectSlackChannels,
    isLoading: selectIsLoading,
    serverError: selectError
});

const mapDispatchToProps = {
    onListSlackChannels: doListSlackChannels,
    onCreate: doCreateSlackChannel
};

export const SlackChannelSelectContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SlackChannelSelect);
